import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import AdvanceRefundWinget from '../../../widgets/advanceRefundWidgets/AdvanceRefundWinget'
import '../styles.less'
import { getExpenseRequest } from '../../../redux/actions/accountingExpenseRequest'
import { sessionGetItemJSON } from '../../../utils/sessionHelpers'
//คืนเงินทดรองจ่าย
export default function AdvanceRefund() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const voucherInfo = sessionGetItemJSON('voucherInfo')
  const borrowId = sessionStorage.getItem('borrowId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getExpenseRequest(projectCode, periodInfo?.periodNumber, borrowId)

      if (response) {
        setSchema(response.model)
        //setSchema(mockSchema)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <AdvanceRefundWinget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
